module.exports = __webpack_public_path__ + "static/media/story-2.1103f596.jpg";